import { LitElement, html, css } from 'lit';
import { accessibility, formStyles } from '../../utilities/styles';
export class AllInPagedFormSuccess extends LitElement {
    static properties = {
        title: { type: String },
        subTitle: { type: String },
        alerts: { type: Array, state: true },
        subscriptionLevel: { type: String },
        dashboardUrl: { type: String },
        enableSubscriptionPrompt: { type: Boolean },
        accessProfileEditNote: { type: String, attribute: 'accessprofileeditnote' },
    };
    constructor() {
        super();
        this.alerts = [];
    }
    render() {
        let subscriptionPrompt = '';
        if (this.name == 'orgsetupform' && this.enableSubscriptionPrompt) {
            subscriptionPrompt = html `\n             <div class="subscription-prompt">\n                <p>Would you like to set up your subscription now?</p>\n                <div class="button-group">\n                    ${this.subscriptionLevel && this.subscriptionLevel !== "0" ? html `\n                        <a href="${this.hardlinks.organisation_dashboard_add_subscription}/?org_id=${this.orgId}&level=${this.subscriptionLevel}" class="button primary">\n                            Add my subscription now\n                        </a>\n                    ` : ''}\n\n                    <a href="${this.dashboardUrl || this.hardlinks.organisation_dashboard}" class="button">\n                        I'd like to explore a bit first\n                    </a>\n                </div>\n            </div>`;
        }
        return html `\n        <div class="message">\n            <h2>${this.title}</h2>\n            <p>${this.subTitle}</p>\n            <slot></slot>\n            ${subscriptionPrompt}\n        </div>\n        <slot></slot>\n        `;
    }
    async setSubPageAlerts(subPages) {
        // Implement logic to handle subPage alerts if needed
        if (!subPages)
            return '';
        let loadedSubPages = await Promise.all(subPages.map(async (page, i) => await subPages[i].updateComplete));
        let alerts = subPages.map((subPage) => {
            let alerts = subPage._alerts?.map(a => a.cloneNode(true));
            if (!alerts)
                return '';
            let children = subPage?.fields;
            if (!children)
                return '';
            let hasSelected = false;
            for (let child of children) {
                if (child.value != 'not_needed' && child.checked) {
                    hasSelected = true;
                    break;
                }
            }
            if (!hasSelected)
                return '';
            return alerts;
        });
        this.alerts = alerts.filter(alert => alert);
    }
    static styles = [
        accessibility,
        css `
        h2{
            font-size: 1.8rem;
            font-weight: 700;
            color: var(--allin-header-color,#472961);
        }
        .button{
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            font-family:var(--allin-font-family,'Montserrat');
            background-color:var(--allin-button-bg-color,#472961);
            font-size:var(--allin-button-font-size,1rem);
            color:var(--allin-button-text-color,#fff);
            font-weight:(var(--allin-button-font-weight,600));
            cursor:pointer;
            border:none;
            text-decoration:none;
            transition:background-color var(--transition) ease;
            margin-bottom:2rem;
            margin-top:1rem;
            width:fit-content;
            display:block;
        }
        .button:hover {
            background-color: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
            font-weight:(var(--allin-button-font-weight,600));
            color: #343434;
        }
        .message.alert{
                padding:1rem;
                border:1px solid var(--allin-secondary-color,#472961);
                display:grid;
                grid-template-columns: 2rem 1fr;
                gap:1rem;
                align-items: center;
                margin:1rem 0;
                background-color:#FFF;
                svg{
                    width:2rem;
                }
                a{
                    color:var(--allin-secondary-color,#472961);
                }
            }
        `
    ];
}
